/**
 * The default page size for a paginator in a list view
 */
export const DEFAULT_PAGE_SIZE = 10;

/**
 * The default page size options for a paginator in a list view
 */
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 100];
